var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import ThumbUpOffAltRoundedIcon from "@mui/icons-material/ThumbUpOffAltRounded";
import ThumbUpRoundedIcon from "@mui/icons-material/ThumbUpRounded";
import { Button, Dialog, InputTextarea, Typography } from "@uigovpe/components";
import { useState } from "react";
var listStyle = {
    display: "grid",
    gap: 16,
};
var nestedListStyle = {
    borderLeft: "1px solid #D1D5DB",
    display: "grid",
    gap: 16,
    marginTop: 12,
    paddingLeft: 16,
};
var itemStyle = {
    display: "grid",
    gap: 8,
};
var textButtonStyle = {
    background: "transparent",
    border: "none",
    color: "#1451B4",
    cursor: "pointer",
    fontSize: 14,
    padding: 0,
};
var actionsRowStyle = {
    alignItems: "center",
    display: "flex",
    gap: 16,
};
var supportButtonStyle = {
    alignItems: "center",
    background: "transparent",
    border: "none",
    cursor: "pointer",
    display: "flex",
    gap: 6,
    padding: 0,
};
var resolveAuthorName = function (comment) {
    var _a;
    if ((_a = comment.user) === null || _a === void 0 ? void 0 : _a.name) {
        return comment.user.name;
    }
    if (comment.userId) {
        return "".concat(comment.userId);
    }
    return "Anônimo";
};
var CommentItem = function (_a) {
    var _b;
    var comment = _a.comment, currentUserId = _a.currentUserId, currentUserRole = _a.currentUserRole, level = _a.level, onAddSupport = _a.onAddSupport, onDeleteComment = _a.onDeleteComment, onRemoveSupport = _a.onRemoveSupport, onSubmitReply = _a.onSubmitReply, onUpdateComment = _a.onUpdateComment, userSupports = _a.userSupports;
    var _c = useState(false), actionsVisible = _c[0], setActionsVisible = _c[1];
    var _d = useState(false), deleteLoading = _d[0], setDeleteLoading = _d[1];
    var _e = useState(false), editLoading = _e[0], setEditLoading = _e[1];
    var _f = useState(comment.content), editValue = _f[0], setEditValue = _f[1];
    var _g = useState(false), isEditing = _g[0], setIsEditing = _g[1];
    var _h = useState(false), replyLoading = _h[0], setReplyLoading = _h[1];
    var _j = useState(false), replyOpen = _j[0], setReplyOpen = _j[1];
    var _k = useState(""), replyValue = _k[0], setReplyValue = _k[1];
    var _l = useState(false), supportLoading = _l[0], setSupportLoading = _l[1];
    var supportId = userSupports === null || userSupports === void 0 ? void 0 : userSupports[comment.id];
    var hasSupported = typeof supportId === "number";
    var canDelete = currentUserId === comment.userId ||
        currentUserRole === "agency_manager" ||
        currentUserRole === "admin_scge";
    var canEdit = currentUserId === comment.userId;
    var canReply = Boolean(onSubmitReply) && level === 0;
    var handleReply = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!onSubmitReply || !replyValue.trim()) {
                        return [2 /*return*/];
                    }
                    setReplyLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, onSubmitReply(comment.id, replyValue.trim())];
                case 2:
                    _a.sent();
                    setReplyOpen(false);
                    setReplyValue("");
                    return [3 /*break*/, 4];
                case 3:
                    setReplyLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleSaveEdit = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!onUpdateComment || !editValue.trim()) {
                        return [2 /*return*/];
                    }
                    setEditLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, onUpdateComment(comment.id, editValue.trim())];
                case 2:
                    _a.sent();
                    setIsEditing(false);
                    return [3 /*break*/, 4];
                case 3:
                    setEditLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleDelete = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!onDeleteComment) {
                        return [2 /*return*/];
                    }
                    setDeleteLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, onDeleteComment(comment.id)];
                case 2:
                    _a.sent();
                    setActionsVisible(false);
                    return [3 /*break*/, 4];
                case 3:
                    setDeleteLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleToggleSupport = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setSupportLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 6, 7]);
                    if (!(hasSupported && onRemoveSupport && typeof supportId === "number")) return [3 /*break*/, 3];
                    return [4 /*yield*/, onRemoveSupport(comment.id, supportId)];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
                case 3:
                    if (!(!hasSupported && onAddSupport)) return [3 /*break*/, 5];
                    return [4 /*yield*/, onAddSupport(comment.id)];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5: return [3 /*break*/, 7];
                case 6:
                    setSupportLoading(false);
                    return [7 /*endfinally*/];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs("div", __assign({ style: itemStyle }, { children: [_jsx(Typography, __assign({ fontWeight: "bold", size: "sm" }, { children: resolveAuthorName(comment) })), _jsxs("div", __assign({ style: {
                    alignItems: "flex-start",
                    display: "flex",
                    gap: 16,
                    justifyContent: "space-between",
                } }, { children: [!isEditing ? (_jsx(Typography, __assign({ size: "sm" }, { children: comment.content }))) : (_jsxs("div", __assign({ style: { display: "grid", gap: 8, width: "100%" } }, { children: [_jsx(InputTextarea, { label: "Editar coment\u00E1rio", onChange: function (event) {
                                    return setEditValue(event.target.value);
                                }, value: editValue }), _jsxs("div", __assign({ style: {
                                    display: "flex",
                                    gap: 8,
                                    justifyContent: "flex-end",
                                } }, { children: [_jsx(Button, { label: "Cancelar", link: true, onClick: function () {
                                            setIsEditing(false);
                                            setEditValue(comment.content);
                                        } }), _jsx(Button, { disabled: editLoading || !editValue.trim(), label: editLoading ? "Salvando..." : "Salvar", onClick: function () { return void handleSaveEdit(); }, size: "small" })] }))] }))), canEdit || canDelete ? (_jsxs(_Fragment, { children: [_jsx("button", __assign({ onClick: function () { return setActionsVisible(true); }, style: __assign(__assign({}, textButtonStyle), { color: "#6B7280", fontSize: 18, lineHeight: 1 }), type: "button" }, { children: "..." })), _jsx(Dialog, __assign({ header: "A\u00E7\u00F5es do coment\u00E1rio", modal: true, onHide: function () { return setActionsVisible(false); }, style: { maxWidth: "max-content", width: "max-content" }, visible: actionsVisible }, { children: _jsxs("div", __assign({ style: {
                                        alignItems: "center",
                                        display: "flex",
                                        gap: 16,
                                        justifyContent: "center",
                                    } }, { children: [canEdit ? (_jsx(Button, { label: "Editar coment\u00E1rio", onClick: function () {
                                                setEditValue(comment.content);
                                                setIsEditing(true);
                                                setActionsVisible(false);
                                            } })) : null, canDelete ? (_jsx(Button, { disabled: deleteLoading, label: deleteLoading ? "Excluindo..." : "Excluir comentário", link: true, onClick: function () { return void handleDelete(); }, severity: "danger" })) : null] })) }))] })) : null] })), _jsxs("div", __assign({ style: actionsRowStyle }, { children: [onAddSupport || onRemoveSupport ? (_jsxs("button", __assign({ "aria-label": hasSupported ? "Remover apoio" : "Apoiar comentário", disabled: supportLoading, onClick: function () { return void handleToggleSupport(); }, style: __assign(__assign({}, supportButtonStyle), { color: hasSupported ? "#1451B4" : "#6B7280", opacity: supportLoading ? 0.7 : 1 }), type: "button" }, { children: [hasSupported ? (_jsx(ThumbUpRoundedIcon, { sx: { fontSize: 16 } })) : (_jsx(ThumbUpOffAltRoundedIcon, { sx: { fontSize: 16 } })), _jsx(Typography, __assign({ size: "xs" }, { children: comment.supportCount || 0 }))] }))) : null, canReply ? (_jsx(Button, { label: replyOpen ? "Cancelar" : "Responder", link: true, onClick: function () { return setReplyOpen(function (currentValue) { return !currentValue; }); } })) : null] })), canReply && replyOpen ? (_jsxs("div", __assign({ style: { display: "grid", gap: 8, paddingLeft: 16 } }, { children: [_jsx(InputTextarea, { label: "Sua resposta", onChange: function (event) {
                            return setReplyValue(event.target.value);
                        }, value: replyValue }), _jsx("div", __assign({ style: { display: "flex", justifyContent: "flex-end" } }, { children: _jsx(Button, { disabled: replyLoading || !replyValue.trim(), label: replyLoading ? "Enviando..." : "Enviar", onClick: function () { return void handleReply(); }, size: "small" }) }))] }))) : null, ((_b = comment.childrenComments) === null || _b === void 0 ? void 0 : _b.length) ? (_jsx("div", __assign({ style: nestedListStyle }, { children: comment.childrenComments.map(function (childComment) { return (_jsx(CommentItem, { comment: childComment, currentUserId: currentUserId, currentUserRole: currentUserRole, level: level + 1, onAddSupport: onAddSupport, onDeleteComment: onDeleteComment, onRemoveSupport: onRemoveSupport, onSubmitReply: onSubmitReply, onUpdateComment: onUpdateComment, userSupports: userSupports }, childComment.id)); }) }))) : null] })));
};
export var CommentsThread = function (_a) {
    var comments = _a.comments, _b = _a.emptyMessage, emptyMessage = _b === void 0 ? "Nenhum comentário ainda." : _b, props = __rest(_a, ["comments", "emptyMessage"]);
    if (comments.length === 0) {
        return (_jsx("div", __assign({ style: { display: "flex", justifyContent: "center" } }, { children: _jsx(Typography, { children: emptyMessage }) })));
    }
    return (_jsx("div", __assign({ style: listStyle }, { children: comments.map(function (comment) { return (_jsx(CommentItem, __assign({ comment: comment, level: 0 }, props), comment.id)); }) })));
};
